import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { getPriceCategoryList } from "../../../../utils/func";

function Price({
    options,
    data 
}) {
    const title = options?.title;
    const category_ids = options?.category_ids;
    const [list,setList] = useState([])

    useEffect(() => {
        getPriceCategoryList(category_ids).then(result => {
            buildArr(result)
        }).catch(err => {

        })
    }, [])

    const buildArr = (result) => {
        let _list = []
        result.map((item,index) => {
            // console.log('25 here result is------------------', item)
            const arr = _list.find(c => c.name === item.name) //list.filter(c => c.name === item.name)

            if(!arr) {
             
                // item.values = []
                const val = findVal(item?.name, item?.content)
            
                item.values = [val]
          
                _list.push(item)
            } else {
                
                const val = findVal(item?.name, item?.content)
                
                arr.values.push(val)
                
                _list.map((i,index) => {
                    if(i.name === arr.name) {
                        _list[index] = arr 
                    }
                })
                
            }
        })


        setList(_list)
    }

    function findVal(nkey, content) {
        let val = '';
        const arr = JSON.parse(content);

        for(let [k , v] of Object.entries(arr)){
            
            if(k === nkey){
                // vals.push(v)
                val = v;
            }
       }
       return val;
    }

    console.log("87 here final list is", list)

    return (
        <div className="section-full text-center sx-pricing-plan-area bg-gray p-t80 p-b50">
            <div className="container">
                {/* TITLE START*/}
                <div className="section-head text-center">
                    <h2 data-title="Our Plan">{title}</h2>
                    <div className="mt-separator-outer">
                        <div className="mt-separator site-bg-primary" />
                    </div>
                </div>
                {/* TITLE END*/}
                <div className="section-content">
                    <div className="pricingtable-row">
                        <div className="row">
                            {
                                list && list?.length > 0 && list.map((item,index) => {
                                    return (
                                        <div key={`item-${index}`} className="col-lg-4 col-md-6 m-b30">
                                            <div className="pricingtable-wrapper pricing-table-style-5 pricing-table-shadow">
                                                <div className="pricingtable-inner bg-gray">
                                                    <div className="pricingtable-price">
                                                        <span className="pricingtable-bx">${item?.price}</span>
                                                        <span className="pricingtable-type">{item?.title}</span>
                                                    </div>
                                                    <div className="pricingtable-title">
                                                        <h3>Basic</h3>
                                                    </div>
                                                    <ul className="pricingtable-features text-black bg-gray">
                                                        {
                                                            item?.values && item?.values?.length > 0 && item?.values?.map((val,idx) => {
                                                                return (
                                                                    <li key={`val-${idx}`}>{val}</li>
                                                                )
                                                            })
                                                        }
                                                       
                                                    </ul>
                                                    <div className="pricingtable-footer">
                                                        <NavLink 
                                                            to={item?.url}
                                                            target="__blank"
                                                            className="site-button text-uppercase">{item?.button_text}</NavLink>
                                                    </div>
                                                    <div className="overlay-main bg-white opacity-07" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Price;
